import createIcon from '../../createIcon';

/**
 * @component @name ViewComfy
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiA0VjExSDIyVjRIMlpNMTAgMjBIMjJWMTNIMTBWMjBaTTIgMjBIOFYxM0gyVjIwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewComfy = createIcon('ViewComfy', [
  ['path', { d: 'M2 4V11H22V4H2ZM10 20H22V13H10V20ZM2 20H8V13H2V20Z', key: 'k7ni97' }],
]);

export default ViewComfy;
